module.exports = __webpack_public_path__ + "img/houseboat-image-MOBILE.35ee5204.jpg";